<template>
  <div class="container">
    <div class="section">
      <div class="is-flex title-actions">
        <title-bar title="Documentos" />
        <button class="button is-intelligential is-pulled-right" @click="openShowModalAdd" v-if="['admin', 'developer', 'manager', 'compliance'].includes(role.code)">
          Agregar
        </button>
      </div>

      <div class="table-container-v3 margin-25">
        <table class="table table-v3 is-fullwidth is-striped">
          <thead>
            <tr>
              <th>ID</th>
              <th>Nombre</th>
              <th>Producto</th>
              <th>Régimen</th>
              <th>Tipo</th>
              <th>Estatus</th>
              <th>Fecha de creación</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody v-if="!isLoading && documentsData.length">
            <tr v-for="(item) in documentsData" :key="item.id">
              <td class="has-text-centered">{{ item.id }}</td>
              <td class="has-text-centered">
                {{ item.name || $t(`documentsTemplateType.${item.documentType.code}`, systemConfiguration.lang) }}
              </td>
              <td class="has-text-centered">
                {{ item.product ? item.product.name : '-' }}
              </td>
              <td class="has-text-centered">
                {{ item.regime ? getRegimeName(item.regime.code) : 'Todos' }}
              </td>
              <td class="has-text-centered">
                {{ item.type || '-' }}
              </td>
              <td class="has-text-centered">
                <span class="is-status" :class="item.enabled ? 'is-status-active' : 'is-status-inactive'">
                  {{ item.enabled ? 'Activo' : 'Borrador' }}
                </span>
              </td>
              <td class="has-text-centered">
                {{ humanDate(item.createdAt, 'DD-MMMM-YYYY', false, 'es') }}
              </td>
              <td class="has-text-centered">
                <div class="dropdown">
                  <a
                    id="panelNavBurger"
                    role="button"
                    data-target="panelNavMenu"
                    aria-expanded="false"
                    aria-label="menu"
                    class="dropbtn"
                  >
                    <i class="fas fa-ellipsis-v" />
                  </a>
                  <div class="dropdown-content">
                    <router-link class="navbar-item" :to="`/document/${item.id}`">
                      <i class="show-on-hover">&gt;</i>
                      Ver detalle
                    </router-link>
                    <a class="navbar-item" @click="openShowModalEnabled(item)" v-if="['admin', 'developer', 'manager', 'compliance'].includes(role.code)">
                      <i class="show-on-hover">&gt;</i>
                      {{ item.enabled ? 'Desactivar' : 'Activar' }}
                    </a>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
          <tbody v-else-if="isLoading">
            <tr>
              <td colspan="7" class="has-text-centered">
                <div class="lds-dual-ring"></div>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="7" class="has-text-centered -text3 -gray">
                Sin información
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="column is-12 has-text-centered">
        <paginator
          :page="pagination.pageNumber"
          :pages="pagination.totalPages"
          :loading="false"
          :action="getLisDocuments"
        />
      </div>
    </div>
    <modal-add-document
      v-if="showModalAdd"
      :close="openShowModalAdd"
      :active="showModalAdd"
      :reload="getLisDocuments"
    />
    <modal-enabled-document
      v-if="showModalEnabled"
      :close="openShowModalEnabled"
      :active="showModalEnabled"
      :item="elementActive"
      :reload="getLisDocuments"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import mixins from '@/mixins/formats'

export default {
  name: 'DocumentosContractuales',
  mixins: [mixins],
  components: {
    TitleBar: () => import('@/components/ui/TitleBar.vue'),
    Paginator: () => import('@/components/ui/BasePagination'),
    ModalAddDocument: () => import('@/components/ContractualDocuments/ModalAddDocument'),
    ModalEnabledDocument: () => import('@/components/ContractualDocuments/ModalEnabledDocument')
  },
  data () {
    return {
      isLoading: true,
      documentsData: [],
      pagination: {
        pageNumber: 1,
        perPage: 10,
        totalPages: 1
      },
      elementActive: null,
      showModalEnabled: false,
      showModalAdd: false
    }
  },
  computed: {
    ...mapState({
      systemConfiguration: state => state.configuration,
      profile: state => state.financialCompany.financialCompany,
      role: state => state.financialCompany.role
    })
  },
  async mounted () {
    await this.getLisDocuments()
  },
  methods: {
    ...mapActions(['getDocumentsTemplate']),
    async getLisDocuments (page = 1) {
      try {
        const { documents, pagination } = await this.getDocumentsTemplate({ pageNumber: page, perPage: 10 })
        this.documentsData = documents
        this.pagination = pagination
      } catch (err) {
      } finally {
        this.isLoading = false
      }
    },
    async downloadDocument (item) {
      // Lógica para descargar
    },
    async uploadDocument (item) {
      // Lógica para actualizar
    },
    openShowModalEnabled (element) {
      this.elementActive = element || null
      this.showModalEnabled = !this.showModalEnabled
    },
    openShowModalAdd () {
      this.showModalAdd = !this.showModalAdd
    },
    getRegimeName (code) {
      const map = {
        PF: 'Persona física',
        PFAE: 'Persona física con actividad empresarial',
        PM: 'Persona moral'
      }
      return map[code]
    }
  }
}
</script>

<style lang="scss" scoped>
.section {
  padding-top: 1rem;
  padding-left: 1rem;
  padding-right: 1rem;
}
.title-actions {
  justify-content: space-between;
}
.mt-4 {
  margin-top: 1rem;
}
.margin-25 {
  margin-top: 25px !important;
}
</style>
